import Button from "components/button";
import ButtonCloseMenu from "components/button-close";
import useMainClass from "hooks/use-main-cass";
import useRouter from "hooks/use-router";

export default function StepPrize() {
  const { history } = useRouter()
  useMainClass('survey-qr__prize')

  return (
    <div className="flex justify-between flex-col items-center h-full w-full">
      <ButtonCloseMenu
        open={true}
        paramFn={() => {
          gtag('event', 'Click', {
            event_category: GTM_EVENT_CATEGORY,
            event_label: 'Survey - Cerrar modal',
            value: '10'
          })
          history.goBack();
        }}
      />
      <div className="w-full px-4 space-y-6 flex flex-col items-center justify-center flex-1 py-6">
        <img src={`${AZURE_BASE_URL}/survey/img_titulo-jalaste_con_todo.webp`} className='mx-auto w-3/4' />
        <img src={`${AZURE_BASE_URL}/survey/img_premio_survey.webp`} className='w-full' />
        <Button onClick={() => history.push('/profile')}>Completa tus datos</Button>
      </div>
    </div>
  )
}